import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import '@mdi/font/css/materialdesignicons.css'
import pt from 'vuetify/es5/locale/pt'

Vue.use(Vuetify, {
  theme: {
    primary: '#004F95',
    secondary: '#009a95',
    accent: '#3d99e5',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107',
    grayLigth: '#E8EAF6',
    darkGray: '#546E7A'
  },
  options: {
    customProperties: true
  },
  iconfont: 'md',
  lang: {
    locales: { pt },
    current: 'pt'
  }
})
